import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import '@indicia/component-library/style.css';

import './i18n';
import router from './routes';
import patchDomForBrowserTranslation from './shared/utils/patch-dom-for-browser-translation';

import './index.scss';
import './shared/styling/global.scss';
import './shared/styling/typography.scss';
import './shared/styling/variables.scss';
import '@progress/kendo-theme-default/dist/all.css';

patchDomForBrowserTranslation();

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
